import axios from 'axios';

// Direct API calls to your PHP backend
const makeAPICall = async (endpoint, method = 'GET', data = null) => {
  const url = `https://protaskar.foxco.com.au/api.php?path=${endpoint}`;
  
  try {
    const config = {
      method,
      url,
      headers: {
        'Content-Type': 'application/json',
      },
    };
    
    if (data) {
      config.data = data;
    }
    
    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
};

// Department API calls
export const departmentAPI = {
  // Get all departments with projects and tasks
  getAll: async () => {
    return await makeAPICall('departments');
  },

  // Create new department
  create: async (name) => {
    return await makeAPICall('departments', 'POST', { name });
  },

  // Update department name
  update: async (id, name) => {
    return await makeAPICall(`departments/${id}`, 'PUT', { name });
  },

  // Delete department
  delete: async (id) => {
    return await makeAPICall(`departments/${id}`, 'DELETE');
  },
};

// Project API calls
export const projectAPI = {
  // Create new project
  create: async (deptId, client, task, dueDate) => {
    return await makeAPICall(`departments/${deptId}/projects`, 'POST', {
      client,
      task,
      dueDate,
    });
  },

  // Update project
  update: async (id, client, task, dueDate) => {
    return await makeAPICall(`projects/${id}`, 'PUT', {
      client,
      task,
      dueDate,
    });
  },

  // Delete project
  delete: async (id) => {
    return await makeAPICall(`projects/${id}`, 'DELETE');
  },
};

// Task API calls
export const taskAPI = {
  // Create new task
  create: async (projId, text, status, dueDate) => {
    return await makeAPICall('tasks', 'POST', {
      projId,
      text,
      status,
      dueDate,
    });
  },

  // Update task
  update: async (id, text, status, dueDate) => {
    return await makeAPICall(`tasks/${id}`, 'PUT', {
      text,
      status,
      dueDate,
    });
  },

  // Toggle task status
  toggleStatus: async (id) => {
    return await makeAPICall(`tasks/${id}/toggle`, 'PATCH');
  },

  // Delete task
  delete: async (id) => {
    return await makeAPICall(`tasks/${id}`, 'DELETE');
  },
};

export default { departmentAPI, projectAPI, taskAPI };